import { Box, Typography } from "@mui/material";
import ProductNotFoundIcon from "@/components/common/icons/productNotFoundIcon";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";

export default function OnlineStoreEmptySection() {
  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  return (
    <Box
      sx={{
        my: isMobile ? 15 : 20,
        textAlign: "center",
      }}
    >
      <ProductNotFoundIcon />
      <Typography variant="h3" sx={{ mt: 3, mb: 1 }}>
        Looks like there’s nothing here...
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
        }}
      >
        We&apos;re working on adding great products soon. Please check back
        later to find something you’ll love!
      </Typography>
    </Box>
  );
}
